import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthenticationService } from './services/authentication.service';
import { UserService } from './services/user.service';
import { RequestsService } from './services/requests.service';
import { User } from 'firebase';
import { DialogService } from 'ng2-bootstrap-modal';
import { RequestComponent } from './modals/request/request.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title:string = 'platzinger';
  user: User= null;
  requests: any =[];
  mailShown : any = [];
  constructor(
    public router: Router, 
    private authenticateService: AuthenticationService,
    private userServices: UserService,
    private requestServices: RequestsService,
    private dialogoService: DialogService
    ){
      this.authenticateService.getStatus().subscribe(
        (status)=>{
          this.userServices.getUserById(status.uid).valueChanges().subscribe(
            (data: User)=>{
              this.user = data;
              this.requestServices.getRequestForEmail(this.user.email).valueChanges().subscribe(
                (requests: any)=>{
                  this.requests = requests;
                  this.requests = this.requests.filter(
                    (raw)=>{
                      return raw.status !== 'accepted' && raw.status !== 'rejected';
                    }
                  );
                  this.requests.forEach(element => {
                    if(this.mailShown.indexOf(element.sender)===-1){
                      this.mailShown.push(element.sender);
                      this.dialogoService.addDialog(RequestComponent, {scope : this, currentRequest: element});
                    }
                  });
                },
                (error)=>{

                }
              );
            },
            (error)=>{

            }
          );
        },
        (error)=>{

        }
      )
  }
}
